import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum DnbPOLineItemKeys {
  itemNumber = 'itemNumber', // line item number, not to be entered by user
  itemName = 'itemName', // name of the item, often SKU, Unique ID, refernce ID, etc
  description = 'description', // verbose description of the item (human parseable)
  itemQty = 'itemQty', // quantity of the item for order
  unitPrice = 'unitPrice', // price per unit - can be rounded up to 4 decimal places
  lineTotal = 'lineTotal', // mapped in to account for rounding errors
}

export const dnbPOFileDataSchema = yup.object().shape({
  issuer: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  orderNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateReady: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  destination: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  vendor: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.number().nullable().optional(),
        itemName: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        itemQty: yup.string().nullable().optional(),
        unitPrice: yup.string().nullable().optional(),
        lineTotal: yup.string().nullable().optional(),
      }),
    )
    .required(),
  agreement: yup.string().nullable().optional(),
  instructions: yup.string().nullable().optional(),
})

export type DnbPOFileData = yup.InferType<typeof dnbPOFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<DnbPOFileData>

export const dnbPOFileMappings: RequiredFileData = {
  issuer: {
    attn: '72a9fee2-1f8d-4f5e-9be4-49f74deb0380',
    companyName: 'e4c00f32-51c6-47b2-9d6b-eb0b848127d0',
    address: '87d0ca2c-b18d-4fa7-b6e3-9f9daa4a5df7',
    phoneNumber: '69e57d9d-bc61-4291-b658-af3aafc72c5c',
    emailAddress: '5e11dea3-f48a-47c3-93dd-1cddda36f751',
  },
  orderNumber: 'f69a70af-d71d-40d0-bb33-58db5eab6eb4',
  paymentTerms: '7d9cfd7f-cf66-401a-939e-9b1bd35b6f4e',
  freightTerms: '4f3d1fa5-86a3-4bbe-9bea-c14b0e62fd11',
  dateIssued: '60fc8ebe-94a9-4f51-9e6a-e91689a23be8',
  dateReady: '29d15e10-6d05-46fe-aaa1-3c76a0a40c0e',
  destination: {
    attn: 'be3dc3b3-4809-4f1e-9dae-a62b49aea2dc',
    companyName: '94ba4ec4-be9c-40ae-8ba3-0e82f036d7c8',
    address: '0c7f2a10-8f9d-4ee5-b2f3-3e91d4a63a58',
    phoneNumber: 'cd5ca2c7-88de-40c7-b77a-733c63d6cb85',
    emailAddress: '0c3f5ceb-7d15-42c9-8c91-db8a5b794bd6',
  },
  vendor: {
    attn: '87b03d0e-b1f8-4f8b-a16c-cf1fe3ef9b1c',
    companyName: '0f0e4b72-73ad-4aa1-9bb3-0cdff697bf2a',
    address: '54dacd44-9a14-407a-8632-94d9fe7dc7d3',
    phoneNumber: '84d17caa-b34d-40be-9fd5-07c27c4dc2ac',
    emailAddress: '9f1dd1a8-50e8-48ca-92f3-4e8a6fc2bd53',
  },
  items: [
    {
      itemNumber: null,
      itemName: 'dc8c99dc-8b06-4f2c-a3d9-7d5ae3987ad4',
      description: '8c03bc31-4dd9-4f05-8b98-1a3e73f2a45c',
      itemQty: 'bc4e1d75-6b99-47c3-9e85-60d9be1a24c3',
      unitPrice: 'e39ccdf8-7d1b-4ad7-b3c4-f5ac71ed83ea',
      lineTotal: '19ead7c1-45de-4bd1-b07f-0e9f526d12e8',
    },
  ],
  agreement: '29ac9e56-14bb-4aea-9fbc-3af96e3c7bf5',
  instructions: '93db5b6b-62cb-483d-80f6-7a5dc6e5e3ef',
}
